// icon:flower | Material Design Icons https://materialdesignicons.com/ | Austin Andrews
import * as React from "react";

export default function BrandLinkedIn(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg"
         viewBox="0 0 14 14"
         fill="currentColor"
         height="1em"
         width="1em"
         {...props}
    >
      <path
            d="M3.13381996 14H.23125516V4.65291634h2.9025648V14ZM1.68097502 3.37788788C.75282931 3.37788788 0 2.60912072 0 1.680975 0 .75259814.75259816 0 1.68097502 0c.92837687 0 1.68097503.75259814 1.68097503 1.680975 0 .92814572-.75314181 1.69691288-1.68097503 1.69691288ZM13.9971875 14h-2.8963147V9.44989843c0-1.08439921-.0218755-2.47505525-1.50909618-2.47505525-1.50909619 0-1.74035135 1.1781513-1.74035135 2.3969285V14H4.95198554V4.65291634h2.78381215v1.27502847h.0406259c.38750866-.7343914 1.33409229-1.5094087 2.74631131-1.5094087 2.9375656 0 3.4775776 1.93441818 3.4775776 4.44697427V14h-.003125Z"/>
    </svg>
  );
}
